<template>
    <div :class="{'androidMode': isAndroidMode(), 'layout-gom': layoutGom}">
        <CircleButton
            style="margin:auto; display:block"
            :icon="handleMinusIcon()"
            :disabled="disabledMinus"
            :big="iconesGrandes"
            @circleBtnClick="handleRemoveClick" v-if="disableControll !== true">
        </CircleButton>
        <span class="item_quantity" :class="{'big-mode': iconesGrandes}" v-text="fixQuantity(quantity)"></span>
        <CircleButton
            style="margin:auto; display:block"
            :icon='plus_orange'
            :disabled="disabledPlus"
            :big="iconesGrandes"
            @circleBtnClick="handleAddClick" v-if="disableControll !== true">
        </CircleButton>
    </div>
    </template>

<script>

import CircleButton from '@/components/buttons/CircleButton'
import Util from '@/assets/libs/util'

export default {
  name: 'QuantityControl',
  components: {
    CircleButton
  },
  data () {
    return {
      minus_orange: require('../../static/icons/minus_orange.svg'),
      plus_orange: require('../../static/icons/plus_orange.svg'),
      iconesGrandes: Util.getLocalConfigs('iconesGrandes')
    }
  },
  props: ['quantity', 'disabledMinus', 'disabledPlus', 'disableControll', 'layoutGom', 'trashIcon'],
  methods: {
    handleAddClick: function () {
      this.$emit('circleBtnAdd')
    },
    handleRemoveClick: function () {
      this.$emit('circleBtnRemove')
    },
    isAndroidMode: function () {
      return Util.isAndroidMode()
    },
    handleMinusIcon: function () {
      return this.trashIcon && this.quantity === 1 ? require('../../static/icons/delete_white.svg') : this.minus_orange
    },
    fixQuantity: function () {
      if (this.quantity < 10) {
        return '0' + this.quantity
      } else {
        return this.quantity
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
    div {
        display: flex;
        width: 100px;
        min-width: 90px;
        max-width: 105px;

        CircleButton {
            width: 20px;
        }

        span {
            width: 100px;
            font-size: 25px;
            font-weight: bold;
            margin: auto;
            display: block;
            text-align: center;
            color: var(--primaryColor);
        }

        .item_quantity.big-mode {
            font-size: 3.0rem;
        }
    }

</style>
